module.exports = __webpack_public_path__ + "adbde6a07d8398a2ce4eeec186f045dc.pdf";